// $(document).ready(function(){
//     console.log('Quiz tracking setup launched! Ready to send events');


//     // Announcement to quiz
//     $(document).on("click",".quiz-button",function() {
//         gtag('event', 'Quiz_clicked_from_header', {
//             'event_category': 'User Actions',
//             'event_label': 'Quiz button',
//             'value': 1
//         });
//         console.log('Quiz_clicked_from_header');
//     });
    

//     // Announcement to quiz
//     $(document).on("click",".sticky-bar-button",function() {
//         gtag('event', 'Quiz_clicked_from_announcement', {
//             'event_category': 'User Actions',
//             'event_label': 'Quiz button',
//             'value': 1
//         });
//         console.log('Clicked from announcment');
//     });


//     // Quiz Question 1
//     $(document).on("click","#gtm_question_passed_1",function() {
//         gtag('event', 'Quiz_passed_question_1', {
//             'event_category': 'User Actions',
//             'event_label': 'Quiz button',
//             'value': 1
//         });
//         console.log('Quiz_passed_question_1');
//     });


//     // Quiz Question 2
//     $(document).on("click","#gtm_question_passed_2",function() {
//         gtag('event', 'Quiz_passed_question_2', {
//             'event_category': 'User Actions',
//             'event_label': 'Quiz button',
//             'value': 1
//         });
//         console.log('Quiz_passed_question_2');
//     });


//     // Quiz Question 3
//     $(document).on("click","#gtm_question_passed_3",function() {
//         gtag('event', 'Quiz_passed_question_3', {
//             'event_category': 'User Actions',
//             'event_label': 'Quiz button',
//             'value': 1
//         });
//         console.log('Quiz_passed_question_3');
//     });

//     // Quiz Question 4
//     $(document).on("click","#gtm_question_passed_4",function() {
//         gtag('event', 'Quiz_passed_question_4', {
//             'event_category': 'User Actions',
//             'event_label': 'Quiz button',
//             'value': 1
//         });
//         console.log('Quiz_passed_question_4');
//     });

//     // Quiz Question 5
//     $(document).on("click","#gtm_question_passed_5",function() {
//         gtag('event', 'Quiz_passed_question_5', {
//             'event_category': 'User Actions',
//             'event_label': 'Quiz button',
//             'value': 1
//         });
//         console.log('Quiz_passed_question_5');
//     });

//     // Quiz Question 5
//     $(document).on("click","#gtm_question_passed_6",function() {
//         gtag('event', 'Quiz_passed_question_6', {
//             'event_category': 'User Actions',
//             'event_label': 'Quiz button',
//             'value': 1
//         });
//         console.log('Quiz_passed_question_6');
//     });


//     // Quiz Question 5
//     $(document).on("click","#gtm_question_passed_7",function() {
//         gtag('event', 'Quiz_passed_question_7', {
//             'event_category': 'User Actions',
//             'event_label': 'Quiz button',
//             'value': 1
//         });
//         console.log('Quiz_passed_question_7');
//     });

//     // Quiz Question 5
//     $(document).on("click","#gtm_question_passed_8",function() {
//         gtag('event', 'Quiz_passed_question_8', {
//             'event_category': 'User Actions',
//             'event_label': 'Quiz button',
//             'value': 1
//         });
//         console.log('Quiz_passed_question_8');
//     });


//     // Quiz Question 5
//     $(document).on("click","#gtm_question_passed_9",function() {
//         gtag('event', 'Quiz_passed_question_9', {
//             'event_category': 'User Actions',
//             'event_label': 'Quiz button',
//             'value': 1
//         });
//         console.log('Quiz_passed_question_9');
//     });


//     // Quiz Question 5
//     $(document).on("click","#gtm_question_passed_10",function() {
//         gtag('event', 'Quiz_passed_question_10', {
//             'event_category': 'User Actions',
//             'event_label': 'Quiz button',
//             'value': 1
//         });
//         console.log('Quiz_passed_question_10');
//     });

//     // Quiz Question 5
//     $(document).on("click","#gtm_question_passed_11",function() {
//         gtag('event', 'Quiz_passed_question_11', {
//             'event_category': 'User Actions',
//             'event_label': 'Quiz button',
//             'value': 1
//         });
//         console.log('Quiz_passed_question_11');
//     });

//     // Quiz Question 5
//     $(document).on("click","#gtm_question_passed_12",function() {
//         gtag('event', 'Quiz_passed_question_12', {
//             'event_category': 'User Actions',
//             'event_label': 'Quiz button',
//             'value': 1
//         });
//         console.log('Quiz_passed_question_12');
//     });


//     // Quiz Question 5
//     $(document).on("click","#gtm_question_passed_13",function() {
//         gtag('event', 'Quiz_passed_question_13', {
//             'event_category': 'User Actions',
//             'event_label': 'Quiz button',
//             'value': 1
//         });
//         console.log('Quiz_passed_question_13');
//     });


//     // Quiz Question 5
//     $(document).on("click","#gtm_question_passed_14",function() {
//         gtag('event', 'Quiz_passed_question_14', {
//             'event_category': 'User Actions',
//             'event_label': 'Quiz button',
//             'value': 1
//         });
//         console.log('Quiz_passed_question_14');
//     });

//     // Quiz Question 5
//     $(document).on("click","#gtm_question_passed_15",function() {
//         gtag('event', 'Quiz_passed_question_15', {
//             'event_category': 'User Actions',
//             'event_label': 'Quiz button',
//             'value': 1
//         });
//         console.log('Quiz_passed_question_15');
//     });


//     // Quiz Question 5
//     $(document).on("click","#gtm_question_passed_16",function() {
//         gtag('event', 'Quiz_passed_question_16', {
//             'event_category': 'User Actions',
//             'event_label': 'Quiz button',
//             'value': 1
//         });
//         console.log('Quiz_passed_question_16');
//     });



//     var currentLocation = String(window.location.href);
    
//     // Viewed emails tep
//     if (currentLocation.indexOf('quiz-email?') != -1){
//         gtag('event', 'Quiz_viewed_email_step', {
//             'event_category': 'User Actions',
//             'event_label': 'Quiz button',
//             'value': 1
//         });
//         console.log('Quiz_viewed_email_step');
//     }


//     // Viewed loading tep
//     if (currentLocation.indexOf('quiz-calculating?') != -1){
//         gtag('event', 'Quiz_viewed_loading_step', {
//             'event_category': 'User Actions',
//             'event_label': 'Quiz button',
//             'value': 1
//         });
//         console.log('Quiz_viewed_loading_step');
//     }


//     // Viewed results tep
//     if (currentLocation.indexOf('quiz-results?') != -1){
//         gtag('event', 'Quiz_viewed_results_step', {
//             'event_category': 'User Actions',
//             'event_label': 'Quiz button',
//             'value': 1
//         });
//         console.log('Quiz_viewed_results_step');
//     }
// });


$(document).ready(function(){
    console.log('Quiz tracking setup launched! Ready to send events');

    function sendGANolimitEvent(eventName, eventLabel) {
        gtag('event', eventName, {
              'event_category': 'User Actions',
              'event_label': eventLabel,
              'value': 1,
              'event_timestamp': Date.now()
          });

          console.log(`${eventName} - Sent`);
    }

    function sendGAEvent(eventName, eventLabel) {
        if (!localStorage.getItem(eventName)) {
            gtag('event', eventName, {
                'event_category': 'User Actions',
                'event_label': eventLabel,
                'value': 1,
                'event_timestamp': Date.now()
            });

            console.log(`${eventName} - Sent`);
            localStorage.setItem(eventName, "true"); // Store in localStorage
        } else {
            console.log(`${eventName} - Already Sent (Skipping)`);
        }
    }

    // Button Click Events
    $(document).on("click",".quiz-button", function() {
        sendGAEvent('Upd_Quiz_clicked_from_header', 'Quiz button');
    });

    $(document).on("click",".sticky-bar-button", function() {
        sendGAEvent('Upd_Quiz_clicked_from_announcement', 'Quiz button');
    });

   $(document).on("click",".Quiz_header_back_inner", function() {
        sendGANolimitEvent('Upd_Quiz_clicked_back', 'Quiz button');
    });

    // Optimized Quiz Question Events (Handles All Questions)
    $(document).on("click", "[id^=gtm_question_passed_]", function() {
        let questionNum = this.id.split('_').pop();
        sendGAEvent(`Upd_Quiz_passed_question_${questionNum}`, 'Quiz button');
    });

    $(document).on("click", ".qz_not_sure__label", function() {
        let questionNum = this.id.split('_').pop();
        sendGAEvent(`Upd_Quiz_passed_question_5`, 'Quiz button');
        sendGAEvent(`Upd_Quiz_breed_skipped`, 'Quiz button');
    });

  

    // Page View Events
    var currentLocation = String(window.location.href);

    if (currentLocation.includes('quiz-email?')) {
        sendGAEvent('Upd_Quiz_viewed_email_step', 'Quiz button');
    }

    if (currentLocation.includes('quiz-calculating?')) {
        sendGAEvent('Upd_Quiz_viewed_loading_step', 'Quiz button');
    }

    if (currentLocation.includes('quiz-results?')) {
        sendGAEvent('Upd_Quiz_viewed_results_step', 'Quiz button');
    }
});

